import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'

import sponsor from '../sponsorship/sponsor.jpg'
// import support from './support.jpg'

const registerURL = 'https://www.eventbrite.com/e/youth-changemaker-summit-scottsdale-tickets-89068790149'

const scholarshipForm = 'https://cohootsfdn.typeform.com/to/bYVLwR'

const RegisterPage = props => {
  return (
    <div>
      <section className="actions grid-x grid-padding-x">
        <div className="cell small-12 medium-auto shrink">
          <h2>Register for Our Next Event:</h2>
        </div>
        <div className="cell auto shrink">
          <a
            className="button"
            href={registerURL}
            rel="noopener, noreferrer"
          >
            Register
          </a>

          <a
            className="button"
            href={scholarshipForm}
            rel="noopener, noreferrer"
          >
            Apply for a Scholarship
          </a>
        </div>
      </section>
      <section className="dark-gray grid-x grid-padding-x align-justify">
        <div className="cell" />
        <div className="cell medium-8">
          <h2>Event Details</h2>

          <p>
            Ever think about all the challenges in the world and how they'll get
            solved? At Youth ChangeMaker Summit, you can learn about how
            business can be a force for positive change in the world by
            imagining and creating your own business team in just 3 days!
          </p>
          <p>
            Meet high schoolers from across the Valley who are also passionate
            about making the world a better place, eat lots of pizza, and
            compete to win scholarship money to the college of your choice!
          </p>
          <hr />
          <p>
            Do you need assistance to attend the event? Ticket scholarships are
            available.
          </p>

          <a
            className="button"
            href={scholarshipForm}
            rel="noopener, noreferrer"
          >
            Apply for a Scholarship
          </a>
        </div>

        <dl className="cell medium-6">
          <h3> Youth ChangeMaker Summit - Scottsdale</h3>

          <dt>Date and Time</dt>
          <dd>
            Friday, February 7th, 2020, 5:00 PM &mdash;<br /> Sunday, February 9th,
            2020, 4:00 PM
          </dd>

          <dt>Location</dt>
          <dd>
            <address>
            Scottsdale Community College
            <br />
            9000 E Chaparral Rd
            <br />
            Scottsdale, AZ 8525
            </address>
          </dd>

          <dt>Cost</dt>
          <dd>
            $99.00<sup>*</sup>
            <br />
            <small>
              <sup>*</sup>Scholarships Available
            </small>
          </dd>
          <dt />
          <dd>
            {' '}
            <a
              className="button"
              href={registerURL}
              rel="noopener, noreferrer"
            >
              Register Now
            </a>
          </dd>
        </dl>
      </section>

      <section className="white grid-x grid-padding-x align-center tac">
        <div className="cell medium-5">
          <img
            src={sponsor}
            alt="Guest speaker talking to students"
            style={{ borderRadius: '8px' }}
          />
          <h2>Ready to support Youth ChangeMaker Summit as a sponsor?</h2>
          <Link className="button" to="/sponsorship/">
            Sponsorship Opportunities
          </Link>
        </div>
      </section>
      <Helmet
        title="Register for Scottsdale 2020 | Youth ChangeMaker Summit"
        meta={[
          {
            name: 'og:title',
            content: 'Register for Youth ChangeMaker Summit Scottsdale 2020',
          },
          {
            name: 'description',
            content: metaDesc,
          },
          {
            name: 'og:description',
            content: metaDesc,
          },
          {
            name: 'og:image',
            content: 'https://ycmsummit.com/img/register-social.jpg',
          },
          {
            name: 'og:image:width',
            content: '600',
          },
          {
            name: 'og:image:height',
            content: '400',
          },
          {
            name: 'twitter:card',
            content: 'summary',
          },
          {
            name: 'twitter:site',
            content: '@ycmsummit',
          },
        ]}
      />
    </div>
  )
}

const metaDesc =
  'Meet high schoolers from across the Valley who are also passionate ' +
  'about making the world a better place, eat lots of pizza, and ' +
  'compete to win scholarship money to the college of your choice!'

export default RegisterPage

export const query = graphql`
  query RegisterPageQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/register/index.js